import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdirectiveInject, ɵɵdefinePipe, Pipe, ɵɵelement, EventEmitter, ɵɵdefineComponent, ɵɵelementStart, ɵɵtemplate, ɵɵtext, ɵɵelementEnd, ɵɵlistener, ɵɵstyleProp, ɵɵproperty, ɵɵadvance, ɵɵtextInterpolate, Component, Input, Output, ɵɵgetCurrentView, ɵɵrestoreView, ɵɵnextContext, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, ɵɵinject, Optional, SkipSelf } from '@angular/core';
import { throwError, BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { MessageType as MessageType$1 } from 'projects/shared-lib/src/lib/constant/message-type.constant';
import { NgSwitch, NgSwitchCase, NgForOf, NgIf, CommonModule } from '@angular/common';
import { MatSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner';

class InstitutionType {
}
InstitutionType.HOSPITAL = 1;
InstitutionType.SCHOOL_DISTRICT = 2;
InstitutionType.AFTER_HOUR_CARE = 18;

class LocalStorageItem {
}
LocalStorageItem.ADMIN_DATA = "ADMIN_DATA";
LocalStorageItem.USER_DATA = "MOBILE_USER_DATA";
LocalStorageItem.USAGE_DATA = "MOBILE_USAGE_DATA";
LocalStorageItem.LANGUAGE = "LANGUAGE";
LocalStorageItem.HOUSEHOLD_ID = "HOUSEHOULD_ID";
LocalStorageItem.PREFERED_INSTITUTITON = "PREFERED_INSTITUTITON";
LocalStorageItem.IS_INSTITUTION_URL = "IS_INSTITUTION_URL";
LocalStorageItem.GUIDELINES_PARAMS = "GUIDELINES_PARAMS";
LocalStorageItem.ACCEPTED_DISCLAIMER = "ACCEPTED_DISCLAIMER";
LocalStorageItem.QS_GROUP = "QS_GROUP";
LocalStorageItem.SURVEY_ID = "SURVEY_ID";
LocalStorageItem.VARIABLE_LIST = "VARIABLE_LIST";
LocalStorageItem.CATEGORY_DATA_TYPES = "CATEGORY_DATA_TYPES";
LocalStorageItem.CATEGORIES = "CATEGORIES";

class MessageType {
}
MessageType.INFORMATIONAL = 0;
MessageType.WARNING = 1;
MessageType.BUSINESS_ERROR = 2;
MessageType.SYSTEM_ERROR = 3;
MessageType.VALIDATION = 4;
MessageType.INTERNAL = 5;
MessageType.DEBUG = 6;
MessageType.HOUSEHOLD = 7;

class QuestionCtrlType {
}
QuestionCtrlType.SINGLE_CHOICE = 1;
QuestionCtrlType.MULTIPLE_CHOICE = 2;
QuestionCtrlType.FREE_TEXT = 3;
QuestionCtrlType.NUMBERIC_TEXT = 4;
QuestionCtrlType.SELECT_ALL_THAT_APPLY = 5;

class TableType {
}
TableType.DECISION = 1;
TableType.PATHWAY = 2;
TableType.QUESTION = 3;
TableType.OPTION = 4;
TableType.TREATMENT = 5;
TableType.SURVEY_QUESTION = 6;
TableType.TYPE_INFORMATION = 7;
TableType.SURVEY_QUESTION_OPTION = 8;

class ServiceConstant {
}
ServiceConstant.somethingWentWrongMessage = "Something was wrong";

class SpinnerService {
    constructor() {
        this.spinnerCache = new Set();
    }
    register(spinner) {
        this.spinnerCache.add(spinner);
    }
    unregister(spinner) {
        this.spinnerCache.delete(spinner);
    }
    show() {
        this.spinnerCache.forEach((spinner) => {
            spinner.showSpinner();
        });
    }
    hide() {
        this.spinnerCache.forEach((spinner) => {
            spinner.hideSpinner();
        });
    }
}
SpinnerService.ɵfac = function SpinnerService_Factory(t) { return new (t || SpinnerService)(); };
SpinnerService.ɵprov = ɵɵdefineInjectable({ token: SpinnerService, factory: SpinnerService.ɵfac, providedIn: "root" });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SpinnerService, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], null, null); })();

class ChildrenModelBase {
}

class TableFilter extends ChildrenModelBase {
}

class QueryableColumn extends ChildrenModelBase {
}

class QueryableTable extends ChildrenModelBase {
}

class ComparerOperator extends ChildrenModelBase {
}

class CombinerAction extends ChildrenModelBase {
}

class TableFilterGroup extends ChildrenModelBase {
}

class DynamicOptCatalog {
}

class ImportInstitutionViewModel {
    constructor(institutions) {
        this.institutions = institutions;
    }
}

class QuestionType extends ChildrenModelBase {
}

class GuidelineLangText {
    constructor(name, description, disclaimer, addInformation) {
        this.name = name;
        this.description = description;
        this.disclaimer = disclaimer;
        this.addInformation = addInformation;
    }
}

class PathwayLangText {
    constructor(name, description, generalConsideration, addInformation) {
        this.name = name;
        this.description = description;
        this.generalConsideration = generalConsideration;
        this.addInformation = addInformation;
    }
}

class BaseClass {
}
class Pathway extends BaseClass {
    constructor() {
        super(...arguments);
        this.questionGroupList = [];
        this.treatmentList = [];
    }
}
class Decision extends BaseClass {
}
class RelatedObject {
    constructor() {
        this.isTemplate = true;
    }
    SetToEmpty() {
        this.id = 0;
        this.text = "";
        this.tag = "";
        this.isTemplate = false;
    }
}
class Treatment extends BaseClass {
    constructor() {
        super(...arguments);
        this.isSaveAs = false;
    }
}
class Option extends BaseClass {
}
class Question extends BaseClass {
}
class ScoreToNextObject extends BaseClass {
}
class QuestionGroup extends BaseClass {
    constructor() {
        super(...arguments);
        this.isSaveAs = false;
    }
}

class Account {
    constructor(username, _token, _expiresIn) {
        this.username = username;
        this._token = _token;
        this._expiresIn = _expiresIn;
    }
    getToken() {
        return this._token;
    }
    getExpiration() {
        return this._expiresIn;
    }
}

class InquiryRequest {
    constructor() {
        this.pageSize = 0;
        this.pageNumber = 0;
        this.withPaging = false;
    }
}

class InquiryResponse {
    constructor() { }
}

class InstitutionByVisitor {
}

class Institution {
    constructor() {
        this.themeElements = [];
        this.facilities = [];
    }
}
class InstitutionThemeElement {
}
class ThemeElement {
}

class LanguageText {
}

class Language extends BaseClass {
    constructor() {
        super(...arguments);
        this.userAppTextItems = [];
        this.decisions = []; // it should have a type
        this.categories = [];
        this.paragraphs = [];
    }
}

class Message {
    constructor(code, type, text) {
        this.code = code;
        this.type = type;
        this.text = text;
    }
}

class PathwayByInstitution {
    constructor(pathwayId, institutionId, rowStatus, createdBy, createdDate, updatedBy, updatedDate, modelAction) {
        this.pathwayId = pathwayId;
        this.institutionId = institutionId;
        this.rowStatus = rowStatus;
        this.createdBy = createdBy;
        this.createdDate = createdDate;
        this.updatedBy = updatedBy;
        this.updatedDate = updatedDate;
        this.modelAction = modelAction;
    }
}

class QuestionOption extends BaseClass {
}

class LoginRequest {
    constructor(username, password) {
        this.username = username;
        this.password = password;
    }
}

class PathwayStatus {
    constructor(id, description, rowStatus, createdBy, createdDate, updatedBy, updatedDate, modelAction) {
        this.id = id;
        this.description = description;
        this.rowStatus = rowStatus;
        this.createdBy = createdBy;
        this.createdDate = createdDate;
        this.updatedBy = updatedBy;
        this.updatedDate = updatedDate;
        this.modelAction = modelAction;
    }
}

class SessionInfo {
    constructor(username, token, expiresIn) {
        this.username = username;
        this.token = token;
        this.expiresIn = expiresIn;
    }
}

class SurveyAnswerRequest {
}

class SurveyAnswer {
}

class SurveyQuestion extends BaseClass {
}

class TreatmentLang {
    constructor(language, readable, editable) {
        this.language = language;
        this.readable = readable;
        this.editable = editable;
    }
}

class UsageDetail {
}

class Usage {
}

class VisitorAccount {
    constructor(username) {
        this.username = username;
    }
}

class Visitor {
}

class NotificationSubscription extends ChildrenModelBase {
}

class LocalStorageUtil {
    constructor() {
    }
    getAdmin() {
        const adminData = JSON.parse(localStorage.getItem(LocalStorageItem.ADMIN_DATA));
        if (adminData) {
            return new Account(adminData.username, adminData._token, adminData._expiresIn);
        }
        else {
            return null;
        }
    }
    saveAdmin(data) {
        localStorage.setItem(LocalStorageItem.ADMIN_DATA, JSON.stringify(data));
    }
    deleteAdmin() {
        localStorage.removeItem(LocalStorageItem.ADMIN_DATA);
    }
    // remove duplicate method from MobileApp/local-storage
    saveHouseHoldId(id) {
        localStorage.setItem(LocalStorageItem.HOUSEHOLD_ID, id);
    }
    getHouseHoldId() {
        return localStorage.getItem(LocalStorageItem.HOUSEHOLD_ID);
    }
    saveQsGroup(qsGroup) {
        localStorage.setItem(LocalStorageItem.QS_GROUP, JSON.stringify(qsGroup));
    }
    getQsGroup() {
        const qsGroup = JSON.parse(localStorage.getItem(LocalStorageItem.QS_GROUP));
        return qsGroup;
    }
    deleteQsGroup() {
        localStorage.removeItem(LocalStorageItem.QS_GROUP);
    }
}
LocalStorageUtil.ɵfac = function LocalStorageUtil_Factory(t) { return new (t || LocalStorageUtil)(); };
LocalStorageUtil.ɵprov = ɵɵdefineInjectable({ token: LocalStorageUtil, factory: LocalStorageUtil.ɵfac, providedIn: "root" });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LocalStorageUtil, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], function () { return []; }, null); })();

class PersistenceAction {
}
PersistenceAction.NONE = 0;
PersistenceAction.INSERT = 1;
PersistenceAction.UPDATE = 2;
PersistenceAction.DELETE = 3;

class HiLowRange {
}

class Category extends ChildrenModelBase {
}

class ParseScoreUtility {
    constructor() {
        this.maxHighValue = 1500;
    }
    parseScore(score) {
        const reg1 = /^(<|>)(=)?(\s)*[0-9]*(\s)*$/; // < number or > number or <= number or >= number
        const reg2 = /^[0-9]+(\s)*[-]{1}(\s)*[0-9]+$/; //Eg: 10 - 20 or 10-20
        const reg3 = /^[0-9]+$/;
        if (reg1.test(score)) {
            if (score[0] == '<')
                return this.lessThanOrEqual(score);
            else
                return this.greaterThanOrEqual(score);
        }
        else if (reg2.test(score)) {
            return this.rangeBased(score);
        }
        else if (reg3.test(score)) {
            let obj = new HiLowRange();
            obj.low = +score;
            obj.high = obj.low;
            return obj;
        }
        return null;
    }
    greaterThanOrEqual(score) {
        let result = new HiLowRange();
        let i = 1;
        if (score[i] == '=')
            i = 2;
        score = score.substring(i);
        let numericData = +score;
        result.low = (i == 1) ? numericData + 1 : numericData; //i==2 when >= 
        result.high = this.maxHighValue;
        return result;
    }
    lessThanOrEqual(score) {
        let result = new HiLowRange();
        let i = 1;
        if (score[i] == '=')
            i = 2;
        score = score.substring(i);
        let numericData = +score;
        result.high = (i == 1) ? numericData - 1 : numericData; //i==2 when >= 
        result.low = 0;
        return result;
    }
    rangeBased(score) {
        let data = score;
        data = data.replace(/\s/g, "");
        let array = data.split('-');
        if (array.length == 2) {
            let result = new HiLowRange();
            result.low = +array[0];
            result.high = +array[1];
            return result;
        }
        return null;
    }
}
ParseScoreUtility.ɵfac = function ParseScoreUtility_Factory(t) { return new (t || ParseScoreUtility)(); };
ParseScoreUtility.ɵprov = ɵɵdefineInjectable({ token: ParseScoreUtility, factory: ParseScoreUtility.ɵfac, providedIn: "root" });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ParseScoreUtility, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], null, null); })();

class ScoreListValidator {
    constructor() {
        this.maxHighValue = 1500;
    }
    getWeightedRangeForMultiSelect(question) {
        let total = 0;
        for (let j = 0; j < question.options.length; j++) {
            let w = +question.options[j].weight;
            total = total + w;
        }
        return +total;
    }
    getWeightedRangeForSingleSelect(question) {
        let range = new HiLowRange();
        range.low = +question.options[0].weight;
        range.high = +question.options[0].weight;
        for (let j = 1; j < question.options.length; j++) {
            if (range.low > question.options[j].weight)
                range.low = +question.options[j].weight;
            else if (range.high < question.options[j].weight)
                range.high = +question.options[j].weight;
        }
        return range;
    }
    getQuestionWeightedRange(group) {
        let range = new HiLowRange();
        range.low = 0;
        range.high = 0;
        for (let i = 0; i < group.questions.length; i++) {
            let question = group.questions[i];
            let result = this.getWeightedRangeForSingleSelect(question);
            if (question.multipleSelection) {
                result.high = this.getWeightedRangeForMultiSelect(question);
            }
            range.low += result.low;
            range.high += result.high;
        }
        let output = new Set();
        for (let i = range.low; i <= range.high; i++)
            output.add(i);
        return output;
    }
    validate(group) {
        if (!group.isScoreBased)
            return null;
        let totalRange = this.getQuestionWeightedRange(group);
        let scoreRange = new Set();
        for (let i = 0; i < group.scoreToNextObjectList.length; i++) {
            let scoreObject = group.scoreToNextObjectList[i];
            let data = scoreObject.score.replace(/\s/g, "");
            let result = this.parseScore(data);
            if (result == null) {
                return ["key", "Invalid range"];
            }
            for (let j = result.low; j <= result.high; j++) {
                if (!scoreRange.has(j)) {
                    scoreRange.add(j);
                }
                else {
                    return ["key", "Overlapping range: " + scoreObject.score];
                }
                if (totalRange.has(j))
                    totalRange.delete(j);
            }
        }
        if (totalRange.size > 0) {
            let error = "";
            for (let s of totalRange) {
                error += s.toString();
                error += ",";
            }
            return [
                "key",
                "Whole range is not covered. Here are items missing: " + error,
            ];
        }
        return null;
    }
    parseScore(score) {
        const reg1 = /^(<|>)(=)?(\s)*[0-9]*(\s)*$/; // < number or > number or <= number or >= number
        const reg2 = /^[0-9]+(\s)*[-]{1}(\s)*[0-9]+$/; //Eg: 10 - 20 or 10-20
        const reg3 = /^[0-9]+$/;
        if (reg1.test(score)) {
            if (score[0] == "<")
                return this.lessThanOrEqual(score);
            else
                return this.greaterThanOrEqual(score);
        }
        else if (reg2.test(score)) {
            return this.rangeBased(score);
        }
        else if (reg3.test(score)) {
            let obj = new HiLowRange();
            obj.low = +score;
            obj.high = obj.low;
            return obj;
        }
        return null;
    }
    greaterThanOrEqual(score) {
        let result = new HiLowRange();
        let i = 1;
        if (score[i] == "=")
            i = 2;
        score = score.substring(i);
        let numericData = +score;
        result.low = i == 1 ? numericData + 1 : numericData; //i==2 when >=
        result.high = this.maxHighValue;
        return result;
    }
    lessThanOrEqual(score) {
        let result = new HiLowRange();
        let i = 1;
        if (score[i] == "=")
            i = 2;
        score = score.substring(i);
        let numericData = +score;
        result.high = i == 1 ? numericData - 1 : numericData; //i==2 when >=
        result.low = 0;
        return result;
    }
    rangeBased(score) {
        let data = score;
        data = data.replace(/\s/g, "");
        let array = data.split("-");
        if (array.length == 2) {
            let result = new HiLowRange();
            result.low = +array[0];
            result.high = +array[1];
            return result;
        }
        return null;
    }
}
ScoreListValidator.ɵfac = function ScoreListValidator_Factory(t) { return new (t || ScoreListValidator)(); };
ScoreListValidator.ɵprov = ɵɵdefineInjectable({ token: ScoreListValidator, factory: ScoreListValidator.ɵfac, providedIn: "root" });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ScoreListValidator, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], null, null); })();

class ExternalUrlUtility {
    processForExternalUrls(htmlText, currentUrl) {
        let start = htmlText.indexOf("<a");
        let end = 0;
        if (start < 0)
            return htmlText;
        let output = htmlText.substring(0, start);
        while (start >= 0) {
            end = htmlText.indexOf("</a>", start);
            if (end <= start) {
                throwError("No matching close tag.");
                return;
            }
            end += 4;
            let closeTag = htmlText.indexOf(">", start + 3);
            if (closeTag <= start) {
                throwError("No matching close tag.");
                return;
            }
            let anchorTag = htmlText.substring(start + 2, closeTag);
            let attributes = this.getAnchorAttributes(anchorTag);
            let hrefAttr = "";
            let targetAttr = "";
            let relAttr = "";
            for (let i = 0; i < attributes.length; i++) {
                let trimmedData = attributes[i].trim();
                if (trimmedData.startsWith("href"))
                    hrefAttr = this.getAttributeValue(trimmedData);
                else if (trimmedData.startsWith("target"))
                    targetAttr = this.getAttributeValue(trimmedData);
                else if (trimmedData.startsWith("rel"))
                    relAttr = this.getAttributeValue(trimmedData);
            }
            output += htmlText.substring(start, closeTag);
            if (this.isExternalUrl(hrefAttr, currentUrl) && targetAttr === "") {
                output += " target='_blank'";
            }
            output += htmlText.substring(closeTag, end);
            start = htmlText.indexOf("<a", end);
            if (start > 1)
                output += htmlText.substring(end, start);
        }
        output += htmlText.substring(end);
        return output;
    }
    isExternalUrl(hrefAttr, currentUrl) {
        let value = hrefAttr.replace(/['"]+/g, '');
        if (value.startsWith("http")) {
            let url = new URL(value);
            if (url.hostname != currentUrl)
                return true;
        }
        return false;
    }
    getAttributeValue(data) {
        let valueStart = data.indexOf("=");
        return data.substring(valueStart + 1).trim();
    }
    getAnchorAttributes(anchorTag) {
        return anchorTag.split(" ");
    }
}
ExternalUrlUtility.ɵfac = function ExternalUrlUtility_Factory(t) { return new (t || ExternalUrlUtility)(); };
ExternalUrlUtility.ɵprov = ɵɵdefineInjectable({ token: ExternalUrlUtility, factory: ExternalUrlUtility.ɵfac, providedIn: "root" });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ExternalUrlUtility, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], null, null); })();

class ToasterService {
    constructor() {
        this.subject = new BehaviorSubject(null);
        this.toast$ = this.subject
            .asObservable()
            .pipe(filter(toast => toast !== null));
    }
    show(msgType, text) {
        this.subject.next({ msgType, text });
    }
}
ToasterService.ɵfac = function ToasterService_Factory(t) { return new (t || ToasterService)(); };
ToasterService.ɵprov = ɵɵdefineInjectable({ token: ToasterService, factory: ToasterService.ɵfac, providedIn: "root" });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ToasterService, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], function () { return []; }, null); })();

class SanitizerPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type) {
        switch (type) {
            case "html":
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case "style":
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case "script":
                return this.sanitizer.bypassSecurityTrustScript(value);
            case "url":
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case "resourceUrl":
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
}
SanitizerPipe.ɵfac = function SanitizerPipe_Factory(t) { return new (t || SanitizerPipe)(ɵɵdirectiveInject(DomSanitizer)); };
SanitizerPipe.ɵpipe = ɵɵdefinePipe({ name: "sanitizer", type: SanitizerPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SanitizerPipe, [{
        type: Pipe,
        args: [{
                name: "sanitizer"
            }]
    }], function () { return [{ type: DomSanitizer }]; }, null); })();

function ToasterComponent_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 8);
} }
function ToasterComponent_img_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 9);
} }
function ToasterComponent_img_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 10);
} }
function ToasterComponent_img_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 10);
} }
function ToasterComponent_img_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 11);
} }
function ToasterComponent_img_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 10);
} }
function ToasterComponent_img_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 12);
} }
class ToasterComponent {
    constructor() {
        this.messageType = MessageType$1;
        this.remove = new EventEmitter();
    }
}
ToasterComponent.ɵfac = function ToasterComponent_Factory(t) { return new (t || ToasterComponent)(); };
ToasterComponent.ɵcmp = ɵɵdefineComponent({ type: ToasterComponent, selectors: [["app-toaster"]], inputs: { toast: "toast", i: "i" }, outputs: { remove: "remove" }, decls: 12, vars: 11, consts: [[1, "toast", "bg-white", "color-dark", 3, "ngSwitch"], ["src", "../../../../assets/done-black-24px.svg", 4, "ngSwitchCase"], ["src", "../../../../assets/warning-black-24px.svg", 4, "ngSwitchCase"], ["src", "../../../../assets/error-black-24px.svg", 4, "ngSwitchCase"], ["src", "../../../../assets/info-black-24px.svg", 4, "ngSwitchCase"], ["src", "../../../../assets/help-black-24px.svg", 4, "ngSwitchCase"], ["id", "notification_msg_pop-up", 1, "toast-text"], [1, "close", 3, "click"], ["src", "../../../../assets/done-black-24px.svg"], ["src", "../../../../assets/warning-black-24px.svg"], ["src", "../../../../assets/error-black-24px.svg"], ["src", "../../../../assets/info-black-24px.svg"], ["src", "../../../../assets/help-black-24px.svg"]], template: function ToasterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, ToasterComponent_img_1_Template, 1, 0, "img", 1);
        ɵɵtemplate(2, ToasterComponent_img_2_Template, 1, 0, "img", 2);
        ɵɵtemplate(3, ToasterComponent_img_3_Template, 1, 0, "img", 3);
        ɵɵtemplate(4, ToasterComponent_img_4_Template, 1, 0, "img", 3);
        ɵɵtemplate(5, ToasterComponent_img_5_Template, 1, 0, "img", 4);
        ɵɵtemplate(6, ToasterComponent_img_6_Template, 1, 0, "img", 3);
        ɵɵtemplate(7, ToasterComponent_img_7_Template, 1, 0, "img", 5);
        ɵɵelementStart(8, "label", 6);
        ɵɵtext(9);
        ɵɵelementEnd();
        ɵɵelementStart(10, "a", 7);
        ɵɵlistener("click", function ToasterComponent_Template_a_click_10_listener() { return ctx.remove.emit(ctx.i); });
        ɵɵtext(11, "\u00D7");
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵstyleProp("bottom", ctx.i * 100, "px");
        ɵɵproperty("ngSwitch", ctx.toast.msgType);
        ɵɵadvance(1);
        ɵɵproperty("ngSwitchCase", ctx.messageType.INFORMATIONAL);
        ɵɵadvance(1);
        ɵɵproperty("ngSwitchCase", ctx.messageType.WARNING);
        ɵɵadvance(1);
        ɵɵproperty("ngSwitchCase", ctx.messageType.BUSINESS_ERROR);
        ɵɵadvance(1);
        ɵɵproperty("ngSwitchCase", ctx.messageType.SYSTEM_ERROR);
        ɵɵadvance(1);
        ɵɵproperty("ngSwitchCase", ctx.messageType.VALIDATION);
        ɵɵadvance(1);
        ɵɵproperty("ngSwitchCase", ctx.messageType.INTERNAL);
        ɵɵadvance(1);
        ɵɵproperty("ngSwitchCase", ctx.messageType.DEBUG);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.toast.text);
    } }, directives: [NgSwitch, NgSwitchCase], styles: [".toast[_ngcontent-%COMP%]{position:fixed;right:15px;top:69px;max-width:90vw;height:100px;padding:.75rem 1.6rem .75rem 1.25rem;margin-top:1rem;border:1px solid transparent;border-radius:.25rem;animation:1s both move;box-shadow:0 3px 7px 0 rgba(0,0,0,.5);z-index:1000;background-color:var(--background);color:var(--black)}.close[_ngcontent-%COMP%]{position:absolute;top:7px;right:10px;font-size:1.5em;cursor:pointer}.toast-text[_ngcontent-%COMP%]{margin-top:10px;font-size:16px;margin-left:.4em!important;color:var(--black)}@keyframes move{from{transform:translateX(100%)}to{transform:translateX(0)}}@media screen and (max-width:576px){.toast[_ngcontent-%COMP%]{top:40px;right:1px}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ToasterComponent, [{
        type: Component,
        args: [{
                selector: "app-toaster",
                template: `
    <div
      class="toast bg-white color-dark"
      [style.bottom.px]="i * 100"
      [ngSwitch]="toast.msgType"
    >
      <img
        *ngSwitchCase="messageType.INFORMATIONAL"
        src="../../../../assets/done-black-24px.svg"
      />
      <img
        *ngSwitchCase="messageType.WARNING"
        src="../../../../assets/warning-black-24px.svg"
      />
      <img
        *ngSwitchCase="messageType.BUSINESS_ERROR"
        src="../../../../assets/error-black-24px.svg"
      />
      <img
        *ngSwitchCase="messageType.SYSTEM_ERROR"
        src="../../../../assets/error-black-24px.svg"
      />
      <img
        *ngSwitchCase="messageType.VALIDATION"
        src="../../../../assets/info-black-24px.svg"
      />
      <img
        *ngSwitchCase="messageType.INTERNAL"
        src="../../../../assets/error-black-24px.svg"
      />
      <img
        *ngSwitchCase="messageType.DEBUG"
        src="../../../../assets/help-black-24px.svg"
      />

      <label id="notification_msg_pop-up" class="toast-text">{{ toast.text }}</label>
      <a class="close" (click)="remove.emit(i)">&times;</a>
    </div>
  `,
                styleUrls: ["./toaster.component.css"]
            }]
    }], null, { toast: [{
            type: Input
        }], i: [{
            type: Input
        }], remove: [{
            type: Output
        }] }); })();

function ToasterContainerComponent_app_toaster_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "app-toaster", 1);
    ɵɵlistener("remove", function ToasterContainerComponent_app_toaster_0_Template_app_toaster_remove_0_listener($event) { ɵɵrestoreView(_r12); const ctx_r11 = ɵɵnextContext(); return ctx_r11.remove($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const toast_r9 = ctx.$implicit;
    const i_r10 = ctx.index;
    ɵɵproperty("toast", toast_r9)("i", i_r10);
} }
class ToasterContainerComponent {
    constructor(toaster) {
        this.toaster = toaster;
        this.toasts = [];
    }
    ngOnInit() {
        this.toaster.toast$
            .subscribe(toast => {
            this.toasts = [toast, ...this.toasts];
            setTimeout(() => this.toasts.pop(), 6000);
        });
    }
    remove(index) {
        this.toasts = this.toasts.filter((v, i) => i !== index);
    }
}
ToasterContainerComponent.ɵfac = function ToasterContainerComponent_Factory(t) { return new (t || ToasterContainerComponent)(ɵɵdirectiveInject(ToasterService)); };
ToasterContainerComponent.ɵcmp = ɵɵdefineComponent({ type: ToasterContainerComponent, selectors: [["app-toaster-container"]], decls: 1, vars: 1, consts: [[3, "toast", "i", "remove", 4, "ngFor", "ngForOf"], [3, "toast", "i", "remove"]], template: function ToasterContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, ToasterContainerComponent_app_toaster_0_Template, 1, 2, "app-toaster", 0);
    } if (rf & 2) {
        ɵɵproperty("ngForOf", ctx.toasts);
    } }, directives: [NgForOf, ToasterComponent], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ToasterContainerComponent, [{
        type: Component,
        args: [{
                selector: 'app-toaster-container',
                template: `
    <app-toaster *ngFor="let toast of toasts; let i=index"
      [toast]="toast" [i]="i"
      (remove)="remove($event)"></app-toaster>
  `,
                styles: []
            }]
    }], function () { return [{ type: ToasterService }]; }, null); })();

function SpinnerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵelementStart(1, "div", 2);
    ɵɵelement(2, "mat-spinner", 3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(2);
    ɵɵproperty("diameter", 40)("mode", "indeterminate");
} }
class SpinnerComponent {
    constructor(spinnerService) {
        this.spinnerService = spinnerService;
        this.numberOfWaits = 0;
    }
    ngOnInit() {
        this.spinnerService.register(this);
    }
    ngOnDestroy() {
        this.spinnerService.unregister(this);
    }
    showSpinner() {
        this.numberOfWaits++;
    }
    hideSpinner() {
        this.numberOfWaits--;
    }
}
SpinnerComponent.ɵfac = function SpinnerComponent_Factory(t) { return new (t || SpinnerComponent)(ɵɵdirectiveInject(SpinnerService)); };
SpinnerComponent.ɵcmp = ɵɵdefineComponent({ type: SpinnerComponent, selectors: [["app-spinner"]], decls: 1, vars: 1, consts: [["class", "spinner-overlay", "id", "spinner", 4, "ngIf"], ["id", "spinner", 1, "spinner-overlay"], [1, "spinner"], [2, "margin", "0 auto", 3, "diameter", "mode"]], template: function SpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, SpinnerComponent_div_0_Template, 3, 2, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.numberOfWaits > 0);
    } }, directives: [NgIf, MatSpinner], styles: [".mat-spinner[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%], [_nghost-%COMP%]    .mat-progress-spinner circle{stroke:var(--primary)}.spinner-overlay[_ngcontent-%COMP%]{height:100vh;width:100%;background-color:var(--shadow);z-index:10;top:0;left:0;position:fixed}.spinner[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%)}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SpinnerComponent, [{
        type: Component,
        args: [{
                selector: "app-spinner",
                templateUrl: "./spinner.component.html",
                styleUrls: ["./spinner.component.css"],
            }]
    }], function () { return [{ type: SpinnerService }]; }, null); })();

class SharedLibraryModule {
}
SharedLibraryModule.ɵmod = ɵɵdefineNgModule({ type: SharedLibraryModule });
SharedLibraryModule.ɵinj = ɵɵdefineInjector({ factory: function SharedLibraryModule_Factory(t) { return new (t || SharedLibraryModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(SharedLibraryModule, { declarations: [SanitizerPipe], imports: [CommonModule], exports: [SanitizerPipe] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(SharedLibraryModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [SanitizerPipe],
                exports: [SanitizerPipe],
            }]
    }], null, null); })();

class EnsureModuleLoadedOnceGuard {
    constructor(targetModule) {
        if (targetModule) {
            throw new Error(`${targetModule.constructor.name} has already been loaded. Import this module in the AppModule only.`);
        }
    }
}

class SpinnerModule extends EnsureModuleLoadedOnceGuard {
    // Ensure that CoreModule is only loaded into AppModule
    constructor(parentModule) {
        super(parentModule);
    }
}
SpinnerModule.ɵmod = ɵɵdefineNgModule({ type: SpinnerModule });
SpinnerModule.ɵinj = ɵɵdefineInjector({ factory: function SpinnerModule_Factory(t) { return new (t || SpinnerModule)(ɵɵinject(SpinnerModule, 12)); }, imports: [[CommonModule, MatProgressSpinnerModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(SpinnerModule, { declarations: [SpinnerComponent], imports: [CommonModule, MatProgressSpinnerModule], exports: [SpinnerComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(SpinnerModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, MatProgressSpinnerModule],
                declarations: [SpinnerComponent],
                exports: [SpinnerComponent],
            }]
    }], function () { return [{ type: SpinnerModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

class ToasterModule extends EnsureModuleLoadedOnceGuard {
    // Ensure that CoreModule is only loaded into AppModule
    constructor(parentModule) {
        super(parentModule);
    }
}
ToasterModule.ɵmod = ɵɵdefineNgModule({ type: ToasterModule });
ToasterModule.ɵinj = ɵɵdefineInjector({ factory: function ToasterModule_Factory(t) { return new (t || ToasterModule)(ɵɵinject(ToasterModule, 12)); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ToasterModule, { declarations: [ToasterContainerComponent, ToasterComponent], imports: [CommonModule], exports: [ToasterContainerComponent, ToasterComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ToasterModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [ToasterContainerComponent, ToasterComponent],
                exports: [ToasterContainerComponent, ToasterComponent],
            }]
    }], function () { return [{ type: ToasterModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

class UserAppText extends BaseClass {
}
class UserAppTextToLanguageMap extends BaseClass {
}

class SurveyQuestionOption extends BaseClass {
}

class SurveyDetail extends BaseClass {
}

class Catalog {
}

class Facility extends ChildrenModelBase {
    constructor() {
        super(...arguments);
        this.units = [];
    }
}

class Unit extends ChildrenModelBase {
}

class EduFamilySurvey extends ChildrenModelBase {
}

class DataType extends ChildrenModelBase {
}

class OptionVariable extends BaseClass {
}

/*
 * Public API Surface of shared-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Account, BaseClass, Catalog, Category, ChildrenModelBase, CombinerAction, ComparerOperator, DataType, Decision, DynamicOptCatalog, EduFamilySurvey, EnsureModuleLoadedOnceGuard, ExternalUrlUtility, Facility, GuidelineLangText, HiLowRange, ImportInstitutionViewModel, InquiryRequest, InquiryResponse, Institution, InstitutionByVisitor, InstitutionThemeElement, InstitutionType, Language, LanguageText, LocalStorageItem, LocalStorageUtil, LoginRequest, Message, MessageType, NotificationSubscription, Option, OptionVariable, ParseScoreUtility, Pathway, PathwayByInstitution, PathwayLangText, PathwayStatus, PersistenceAction, QueryableColumn, QueryableTable, Question, QuestionCtrlType, QuestionGroup, QuestionOption, QuestionType, RelatedObject, SanitizerPipe, ScoreListValidator, ScoreToNextObject, ServiceConstant, SessionInfo, SharedLibraryModule, SpinnerComponent, SpinnerModule, SpinnerService, SurveyAnswer, SurveyAnswerRequest, SurveyDetail, SurveyQuestion, SurveyQuestionOption, TableFilter, TableFilterGroup, TableType, ThemeElement, ToasterComponent, ToasterContainerComponent, ToasterModule, ToasterService, Treatment, TreatmentLang, Unit, Usage, UsageDetail, UserAppText, UserAppTextToLanguageMap, Visitor, VisitorAccount };
//# sourceMappingURL=shared-lib.js.map
